export function logout(){
    console.log("called logout function");
    //localStorage.clear();
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    window.location.href = "/signin"; 
    return true;
}